import styled from '@emotion/styled';
import { Slider } from '@mui/material';

export const SliderMain = styled(Slider)``;
